import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { CommonModule } from '@angular/common';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi
} from '@angular/common/http';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { AuthModule as AuthLibModule } from '@auth/auth';
import { AppComponent } from './app.component';
import { LoginGuard } from './guards/login.guard';
import { HeaderComponent } from './header/header.component';
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { SessionStorage } from './services';
import { ShellService } from './services/shell.service';
import { AppRoutingModule } from './app-routing.module';
import { RootInterceptor } from './interceptors/root.interceptor';
import {
  CdsNavigationModule,
  CdsPageHeaderModule,
  CdsLoadingOverlayModule
} from '@cds/angular';
import { UrlSerializer } from '@angular/router';
import { UrlSerializerService } from './services/url-serializer.service';
import { NotfoundComponent } from './notfound/notfound.component';
import { MaintenanceComponent } from './maintenance/maintenance.component';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    NotfoundComponent,
    MaintenanceComponent
  ],
  bootstrap: [AppComponent],
  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    MatIconModule,
    MatToolbarModule,
    AuthLibModule.forRoot(),
    CdsPageHeaderModule,
    CdsNavigationModule,
    CdsLoadingOverlayModule
  ],
  providers: [
    SessionStorage,
    LoginGuard,
    { provide: 'ShellService', useClass: ShellService },
    // Should be added before root interceptor
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    // Should be added last
    { provide: HTTP_INTERCEPTORS, useClass: RootInterceptor, multi: true },
    {
      provide: UrlSerializer,
      useClass: UrlSerializerService
    },
    provideHttpClient(withInterceptorsFromDi())
  ]
})
export class AppModule {}
